// Module
var code = "<span ng-transclude></span>";
// Exports
module.exports = code;